import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
const initialTestimonials = [{
  initials: 'MP',
  quote: 'Usé el Tomo 7 el mismo día que lo descargué. Nunca más me rechazaron un informe de obra social.',
  name: 'Martín P.',
  location: 'Buenos Aires',
  role: 'Kinesiólogo Independiente'
}, {
  initials: 'CG',
  quote: 'Tenía miedo de un post-quirúrgico de rodilla. Con el protocolo en la mano trabajé con seguridad desde la primera sesión.',
  name: 'Carolina G.',
  location: 'Córdoba',
  role: 'Kinesióloga en Consultorio Propio'
}, {
  initials: 'FR',
  quote: 'Antes tardaba 2 horas armando un informe de evolución. Ahora son 10 minutos con la plantilla.',
  name: 'Federico R.',
  location: 'Rosario',
  role: 'Kinesiólogo Independiente'
}];
const finalTestimonials = [{
  initials: 'MP',
  name: 'Martín P.',
  location: 'Buenos Aires 🇦🇷',
  quote: 'Usé el Tomo 7 el mismo día que lo descargué. Me aprobaron el informe de OSDE sin modificaciones. Primera vez que me pasa.'
}, {
  initials: 'CG',
  name: 'Carolina G.',
  location: 'Córdoba 🇦🇷',
  quote: 'Tenía un post-quirúrgico de LCA y no sabía por dónde empezar. El Ebook Elite 2 me dio la seguridad que necesitaba. El paciente llegó al alta sin complicaciones.'
}, {
  initials: 'FR',
  name: 'Federico R.',
  location: 'Rosario 🇦🇷',
  quote: 'Antes tardaba 2 horas armando un informe de evolución. Ahora son 10 minutos. La plantilla del Tomo 7 es exactamente lo que la obra social pide.'
}, {
  initials: 'SV',
  name: 'Sofía V.',
  location: 'Mendoza 🇦🇷',
  quote: 'El Detective Clínico cambió cómo evalúo. Encontré la causa real de una lumbalgia crónica que 3 kinesiólogos anteriores no pudieron resolver.'
}, {
  initials: 'DA',
  name: 'Diego A.',
  location: 'Santa Fe 🇦🇷',
  quote: 'Los Scripts de WhatsApp del Bonus 4 me ayudaron a bajar el ausentismo un 40%. Mis pacientes confirman el turno y no se olvidan.'
}, {
  initials: 'CR',
  name: 'Claudia R.',
  location: 'Tucumán 🇦🇷',
  quote: 'El Tomo 1 me ayudó a entender que estaba regalando mi trabajo. Ajusté mis tarifas y no perdí ningún paciente. Todo lo contrario.'
}];
export const InitialTestimonials = () => {
  return <section className="py-16 bg-slate-50 px-4 sm:px-6 lg:px-8" data-id="element-242">
      <div className="max-w-7xl mx-auto" data-id="element-243">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-244">
          {initialTestimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col h-full" data-id="element-245">
              <div className="flex gap-1 mb-4" data-id="element-246">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-247" />)}
              </div>
              <p className="text-slate-700 italic mb-6 flex-grow text-lg" data-id="element-248">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-249">
                <div className="w-12 h-12 bg-teal-100 text-teal-800 font-bold rounded-full flex items-center justify-center text-lg" data-id="element-250">
                  {t.initials}
                </div>
                <div data-id="element-251">
                  <p className="font-bold text-slate-900" data-id="element-252">{t.name}</p>
                  <p className="text-sm text-slate-500" data-id="element-253">
                    {t.location} | {t.role}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};
export const FinalTestimonials = () => {
  return <section className="py-20 bg-slate-50 px-4 sm:px-6 lg:px-8" data-id="element-254">
      <div className="max-w-7xl mx-auto" data-id="element-255">
        <div className="text-center mb-12" data-id="element-256">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4" data-id="element-257">
            Lo que dicen los kinesiólogos
          </h2>
          <div className="flex items-center justify-center gap-2 text-2xl font-bold text-slate-700" data-id="element-258">
            4.9/5 <Star className="w-8 h-8 fill-yellow-400 text-yellow-400" data-id="element-259" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-260">
          {finalTestimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 flex flex-col" data-id="element-261">
              <div className="flex items-center gap-4 mb-4" data-id="element-262">
                <div className="w-10 h-10 bg-teal-700 text-white font-bold rounded-full flex items-center justify-center" data-id="element-263">
                  {t.initials}
                </div>
                <div data-id="element-264">
                  <p className="font-bold text-slate-900" data-id="element-265">{t.name}</p>
                  <p className="text-xs text-slate-500" data-id="element-266">{t.location}</p>
                </div>
                <div className="ml-auto flex" data-id="element-267">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-268" />)}
                </div>
              </div>
              <p className="text-slate-600 text-sm leading-relaxed" data-id="element-269">
                "{t.quote}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};
export const Guarantee = () => {
  return <section className="py-16 bg-white px-4 sm:px-6 lg:px-8" data-id="element-270">
      <div className="max-w-3xl mx-auto text-center" data-id="element-271">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-50 rounded-3xl p-8 md:p-12 border-2 border-slate-200 relative overflow-hidden" data-id="element-272">
          <div className="absolute top-0 left-0 w-full h-2 bg-teal-600" data-id="element-273"></div>
          <div className="mx-auto w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mb-6" data-id="element-274">
            <ShieldCheck className="w-10 h-10 text-teal-700" data-id="element-275" />
          </div>
          <h2 className="text-3xl font-extrabold text-slate-900 mb-6" data-id="element-276">
            🛡️ Garantía 7 días sin preguntas
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-277">
            Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Élite en tu
            consultorio. Si no es lo que esperabas → 100% de devolución. Sin
            preguntas. Sin formularios. Sin drama.
          </p>
          <div className="inline-block bg-white border border-slate-200 text-slate-700 font-bold px-6 py-3 rounded-full shadow-sm" data-id="element-278">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </motion.div>
      </div>
    </section>;
};